import { Action } from 'redux';
import {
  CARBON_INTENSITY_FETCH,
  CARBON_INTENSITY_RESET,
} from 'src/modules/carbon-intensity/actions/CarbonIntensityActions';
import { CarbonIntensityState } from 'src/modules/carbon-intensity/types/CarbonIntensityState';

export function carbonIntensityDataReducer(state: CarbonIntensityState, action: Action): CarbonIntensityState {
  if (CARBON_INTENSITY_FETCH.is(action)) {
    return new Map(action.data.map((it) => [it.country, it]));
  }
  if (CARBON_INTENSITY_RESET.is(action)) {
    return new Map();
  }

  return state;
}
